import { render, staticRenderFns } from "./rolesAdd.vue?vue&type=template&id=1bb525b2"
import script from "./rolesAdd.vue?vue&type=script&lang=js"
export * from "./rolesAdd.vue?vue&type=script&lang=js"
import style0 from "./rolesAdd.vue?vue&type=style&index=0&id=1bb525b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports